import { CheckCircle2, HelpCircle, XCircle, Gift, Clock } from "lucide-react";

export const LIKELINESS_OPTIONS = ["YES", "MIGHT", "NOT", "PENDING", "CANCELLED", "FREE"];

// Used in the new-sub modal and on PENDING subs in the edit modal — these are
// the only valid likeliness values before the customer has paid anything.
export const LIKELINESS_OPTIONS_UNPAID = ["PENDING", "FREE"];

export const LIKELINESS_COLORS = {
  YES: "bg-emerald-100 text-emerald-700",
  MIGHT: "bg-amber-100 text-amber-700",
  NOT: "bg-red-100 text-red-700",
  PENDING: "bg-sky-100 text-sky-700",
  CANCELLED: "bg-slate-100 text-slate-700",
  FREE: "bg-purple-100 text-purple-700"
};

export const LIKELINESS_ICONS = {
  YES: CheckCircle2,
  MIGHT: HelpCircle,
  NOT: XCircle,
  PENDING: Clock,
  CANCELLED: XCircle,
  FREE: Gift
};

export const formatCurrency = (amount) => {
  if (!amount) return "—";
  return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(amount);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString();
};

export const LikelinessIcon = ({ type }) => {
  const Icon = LIKELINESS_ICONS[type];
  return Icon ? <Icon className="w-4 h-4" /> : null;
};
